import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PromoBreadcrumb = ({ currentName }) => {
  return (
    <Breadcrumb>
      <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/promos' }}>
        Promos
      </Breadcrumb.Item>
      <Breadcrumb.Item active>{currentName ? currentName : `Current Promo`}</Breadcrumb.Item>
    </Breadcrumb>
  );
};

export default PromoBreadcrumb;
